import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts/')({
  beforeLoad: () => {
    throw redirect({
      to: '/devices/alerts/to-be-assigned'
    });
  }
});